export default {"src":"/_next/static/media/Group 48097642.6eec4620.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};